<template>
  <div class="calendar_box">
    <FullCalendar
        class='demo-app-calendar'
        :options='calendarOptions'
        :onselect="onDateSelect"
        ref="fullCalendar"
    >
      <template v-slot:eventContent='arg'>
        <div :class="arg.event.extendedProps.type">
          {{ arg.event.extendedProps.content }}
        </div>
      </template>

    </FullCalendar>

    <div class="my_toolbar">
      <el-select v-model="formData.user_id" placeholder="人员" class="toolbar_item" style="width: 130px" @change="scheduleQuery">
        <el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-button type="primary" @click="scheduleQuery" class="toolbar_item">查询</el-button>
    </div>

    <div style="margin-top: 5px;margin-left: 10px">

    </div>

    <!--日程详情dialog -->
    <el-dialog title="日程详情" :model="form" v-model="dialogForm" style="width: 600px">
      <el-form label-width="150px">
        <el-row>
          <el-col :span="18" style="margin-top: 10px">{{ form.schedule_date }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="18" style="margin-top: 10px">{{ form.user_name }} - {{ form.type }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="18" style="margin-top: 10px">{{ form.start_time }} - {{ form.end_time }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="18" style="margin-top: 10px">{{ form.content }}</el-col>
        </el-row>

        <el-row v-if="form.result == 'schedule_partial' || form.result == 'schedule_no_start'">
          <el-col :span="18" style="margin-top: 10px">
            <el-input type="textarea" placeholder="备注" v-model="form.remark" style="width: 400px" clearable></el-input>
          </el-col>
        </el-row>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

export default {
  name: "AttendanceCalendar",
  components: {
    FullCalendar,
  },
  data() {
    return {
      activeName: 'first',
      rules: {
        star: [{required: true, message: '', trigger: 'blur'}],
      },
      // scheduleType: [],
      // scheduleState: [],
      userList: [],
      dialogForm: false,
      dialogFormVisible: false,
      dialogFormExport: false,
      users: [],
      params: {},
      viewVisible: false,
      selectId: 0,
      selectDate: '',
      saveVisible: false,
      queryListEventMap: {
        button_id: '',
        query_id: '',
        start_date: ''
      },
      formExport: {
        user_id: '',
        export_start_time: '',
        export_end_time: ''
      },
      form: {
        id: '',
        user_id: '',
        user_name: '',
        title: '',
        type: '',
        comments: '',
        result: '',
        start_time: '',
        end_time: '',
        remark: '',
        commentsList: []
      },
      formData: {
        schedule_date: '',
        user_id: '',
        content: '',
        type: '',
        result: '',
        start_time: '',
        end_time: '',
        remind_time: ''
      },
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        aspectRatio: 2.4,
        allDaySlot: false,
        locale: "zh-cn",
        fixedWeekCount: false,
        customButtons: {
          next: {
            click: this.nextClick
          },
          prev: {
            click: this.prevClick
          },
          today: {
            text: "今天",
            click: this.todayClick
          },
        },
        headerToolbar: {
          left: "prev,next,today",
          center: "title",
          right: "",
        },
        initialView: "timeGridWeek",
        events: [],
        firstDay: 1,
        editable: false,
        selectable: true,
        // selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        eventClick: this.handleEventClick,
        select: this.onDateSelect,
        slotMinTime: '07:00:00'
      },
      currentEvents: [],
      eventGuid: 0,
    };
  },
  computed: {

  },
  created() {
    this.fullName();
    this.scheduleQuery()
    this.getUserList()
  },
  methods: {
    windowResize() {
      this.$refs.fullCalendar.getApi().updateSize()
    },
    nextClick() {
      this.$refs.fullCalendar.getApi().next()
      this.scheduleQuery()
    },

    prevClick() {
      this.$refs.fullCalendar.getApi().prev()
      this.scheduleQuery()
    },

    todayClick() {
      this.$refs.fullCalendar.getApi().today()
      this.scheduleQuery()
    },

    clearData() {
      this.formData.schedule_date = ''
      this.formData.schedule_range = ''
      this.formData.content = ''
      this.formData.type = ''
      this.formData.result = ''
      this.formData.start_time = ''
      this.formData.end_time = ''
      this.form.user_id = ''
      this.form.title = ''
      this.form.comments = ''
      this.form.type = ''
      this.form.result = ''
      this.form.start_time = ''
      this.form.end_time = ''
      this.form.remark = ''
      this.dialogFormVisible = false;
    },

    fullName() {
      this.formData.user_id = this.$store.state.core.currentUser?.id
    },

    isExport() {
      this.dialogFormExport = true;
    },

    //查询日程
    async scheduleQuery() {
      if (!this.formData.user_id) {
        return
      }
      this.calendarOptions.events = await this.$http('oaAttendanceService.getAttendanceCalendar', this.formData)
    },

    //查询详情
    async handleEventClick(clickInfo) {
      console.log("1111111111=" ,clickInfo)
      /*
      this.clearData()
      this.dialogForm = true;

      let params = {id:clickInfo.event.id}
      this.form = await this.$http('oaScheduleService.getScheduleDetails', params)
      */
    },

    async getUserList() {
      this.userList = await this.$http('oaAttendanceService.getSubUsers')
    }
  },

}

Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}

</script>

<style>
/* 去掉控件里的边框，背景色*/
.fc-v-event {
  background-color: white !important;
  border: none !important;
}

.fc-timegrid-event{
  box-shadow: none !important;
}

.fc-highlight{
  background: rgba(188,232,241,.7)  !important;
}

.fc-event-main{
  padding: 1px 0px 1px !important;
}

</style>

<style lang="less" scoped>
.calendar_box {
  width: 100%;
  height: 80%;
  padding: 20px;
}

.my_toolbar {
  position: absolute;
  top: 25px;
  right: 50px;
  text-align: left;
  line-height: 40px;
  vertical-align: middle;
  /*border: 1px dotted lightgray;*/
  display: inline-flex;

}

.toolbar_item {
  margin-right: 10px;
}

.schedule_business_trip{
  background-color: burlywood;
  border-left: 4px solid orange;
  color: #ffffff;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule_normal{
  background-color: lightgreen;
  border-left: 4px solid #42b983;
  color: #0a84ff;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule_leave{
  background-color: lightcoral;
  border-left: 4px solid red;
  color: #ffffff;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule_out{
  background-color: lightcoral;
  border-left: 4px solid red;
  color: #ffffff;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule_overtime{
  background-color: #b3e19d;
  border-left: 4px solid #95d475;
  color: #ffffff;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule_attendance{
  background-color: #87CEFA;
  border-left: 4px solid #1a70ff;
  color: #ffffff;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scheduleDetail {
  font-size: 16px;
}

</style>